import axios from "axios";
import imageCompression from "browser-image-compression";
import { useGlobalContext } from "../../GlobalContext";

export default function useDriverKYCUpload() {
  const { baseurl, token, AdminId } = useGlobalContext();

  /* ================= IMAGE COMPRESSION ================= */

  const compressImageMax = async (file) => {
    try {
      const options = {
        maxSizeMB: 0.1,
        maxWidthOrHeight: 600,
        useWebWorker: true,
        fileType: "image/jpeg",
        quality: 0.7,
        initialQuality: 0.7,
      };

      const compressedFile = await imageCompression(file, options);

      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = () => {
          let base64 = reader.result;
          base64 = base64.replace(
            /^data:image\/(jpeg|png|webp|jpg);base64,/,
            ""
          );
          resolve(base64);
        };
        reader.onerror = reject;
        reader.readAsDataURL(compressedFile);
      });
    } catch (err) {
      console.error("Image compression failed", err);
      throw err;
    }
  };

  /* ================= UPLOAD IMAGE TO SERVER ================= */

  const uploadImageToServer = async (imageFile, driverCode, imageType) => {
    if (typeof imageFile === "string") return imageFile;

    try {
      const compressedBase64 = await compressImageMax(imageFile);

      const payload = {
        userid: driverCode,
        item_name: `${driverCode}_${imageType}`,
        image_data: compressedBase64,
        type: imageType,
        adminId: AdminId,
      };

      const res = await axios.post(
        "https://bumppy.in/packky/api/v1/uploadKycImage.php",
        payload,
        {
          headers: {
            Authorization: `Basic ${token}`,
            "Content-Type": "application/json",
          },
        }
      );

      if (res.data && (res.data.status === "0" || res.data.status === 0)) {
        return (
          res.data.image_url ||
          `${baseurl}/uploads/kyc/${driverCode}_${imageType}.jpg`
        );
      }

      throw new Error(res.data?.msg || "Image upload failed");
    } catch (err) {
      console.error(`Upload failed for ${imageType}`, err);
      throw err;
    }
  };

  return {
    compressImageMax,
    uploadImageToServer,
  };
}
